'use client';

import {
  ThemeProvider as NextThemesProvider,
  type ThemeProviderProps,
} from '@teispace/next-themes';

export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
  return (
    <NextThemesProvider
      attribute='class'
      defaultTheme='system'
      enableSystem
      storage='local'
      {...props}
    >
      {children}
    </NextThemesProvider>
  );
}
